module.exports = __webpack_public_path__ + "static/media/Assets-06-Books-of-type-halftone.a142b904.jpg";